/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Ws_TitleInputs */

const en_settings_ws_title = /** @type {(inputs: Settings_Ws_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace ID`)
};

const id_settings_ws_title = /** @type {(inputs: Settings_Ws_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace ID`)
};

/**
* | output |
* | --- |
* | "Workspace ID" |
*
* @param {Settings_Ws_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_ws_title = /** @type {((inputs?: Settings_Ws_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Ws_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_ws_title(inputs)
	return en_settings_ws_title(inputs)
});